import React from 'react';
import filterSampleListOnMatchers from
  '@avtechsoftware/ra-javascript-utilities/src/utilities/samples/SampleUtility';
import SensorCapacity
  from '@avtechsoftware/react-component-library/src/components/sensorcapacity/SensorCapacity/SensorCapacity';
import { connect } from 'react-redux';
import BaseDevice from '@avtechsoftware/ra-javascript-utilities/src/classes/devices/BaseDevice';
import PropTypes from 'prop-types';
import {
  selectAllProducts,
  selectProductsByCategory,
} from '../../../redux/slices/productsSlice/productsSlice';
import envConfig from '../../../envConfig';
import { selectRoomAlertDeviceList } from '../../../redux/slices/deviceList/deviceListSlice';
import RaaAuthenticatedRemoteService from '../../../utility/RaaAuthenticatedRemoteService';
import { sessionHash } from '../../../utility/remoteServiceUtil';

class SensorCapacityPageConnected extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      latestSamples: {},
    };
  }

  componentDidMount() {
    this.getSampleList();
  }

  getSampleList() {
    return RaaAuthenticatedRemoteService.globalInstance().get(`${envConfig.apiUrl}/api/v1/device-data/latest-samples?auth_token=${sessionHash}`)
      .then((responseData) => {
        const { sampleList } = responseData;
        this.setState({ latestSamples: filterSampleListOnMatchers(sampleList, ['1300_0_21_0_*']) });
      }).catch(() => {
        this.setState({ latestSamples: {} });
      });
  }

  render() {
    const {
      productsContext,
      deviceList,
    } = this.props;

    const {
      latestSamples,
    } = this.state;

    return (
      <>
        <SensorCapacity
          productList={productsContext.findAll().filter((product) => product.id !== 85)}
          masterDeviceList={deviceList}
          latestSamples={latestSamples}
        />
      </>
    );
  }
}

SensorCapacityPageConnected.propTypes = {
  productsContext: PropTypes.shape({
    findAll: PropTypes.func.isRequired,
    findAllByCategoryId: PropTypes.func.isRequired,
  }).isRequired,
  deviceList: PropTypes.arrayOf(PropTypes.instanceOf(BaseDevice)).isRequired,
};
/* istanbul ignore next */
const mapStateToProps = (state) => ({
  productsContext: {
    findAll: () => selectAllProducts(state),
    findAllByCategoryId: (categoryId) => selectProductsByCategory(state, categoryId),
  },
  deviceList: selectRoomAlertDeviceList(state),
});

export { SensorCapacityPageConnected };
export default
connect(mapStateToProps)(SensorCapacityPageConnected);
